import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import { hot } from 'react-hot-loader'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from 'components/footer'
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using the fullPage.js option scrollOverflow:true
import ReactFullpage from '@fullpage/react-fullpage'
import AudioPlayer from 'components/audioplayer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

const ARTICLE_ID = '25579189'

const img0 = require('./img/00.jpg')
const img0mobile = require('./img/00-mobile.jpg')

const imgTrench = require('./img/trench.jpg')
const imgTrenchMobile = require('./img/trench-mobile.jpg')
const imgTrenchTablet = require('./img/trench-tablet.jpg')

class AppComponent extends React.Component {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800,
      slideTransition: 'slide', // slide|fade
      slideDirection: '', // up|down
      invertedSection: true,
      publicationDate: '1544177820',
    }
    this.onLeave = this.onLeave.bind(this)
    this.afterLoad = this.afterLoad.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
  }

  updateDimensions() {
    console.log('updateDimensions')
    this.setState({ isMobile: window.innerWidth < 650 })
    this.setState({ isTablet: window.innerWidth < 800 })
  }

  isInverted(value) {
    return value === 'inverted'
  }

  onLeave(index, nextIndex, direction) {
    this.setState({ slideDirection: direction }, function () {
      // change header colors?
      const classList = nextIndex.item.classList
      const sectionClasses = Array.from(classList)
      if (this.state.slideDirection === 'up') {
        if (sectionClasses.indexOf('inverted') === -1) {
          this.setState({ invertedSection: true })
        } else {
          this.setState({ invertedSection: false })
        }
      }
    })
    // console.log('nextIndex: ', nextIndex.index)
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'scroll',
      event_label: `scrolled to: ${nextIndex.index}`,
    })
  }

  afterLoad(anchorLink, index, slideAnchor, slideIndex) {
    // change header colors?
    const classList = index.item.classList
    const sectionClasses = Array.from(classList)
    if (this.state.slideDirection === 'down') {
      if (sectionClasses.indexOf('inverted') === -1) {
        this.setState({ invertedSection: true })
      } else {
        this.setState({ invertedSection: false })
      }
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
  }

  render() {
    return (
      <div className={'index ' + this.state.slideTransition}>
        <Masthead
          inverted={this.state.invertedSection}
          articleId={ARTICLE_ID}
        />
        <ReactFullpage
          onLeave={this.onLeave}
          afterLoad={this.afterLoad}
          navigation
          navigationPosition='right'
          navigationTooltips={['', '', '']}
          normalScrollElements='.comparison-wrapper'
          licenseKey='9B91FA5D-FFD748B8-88A4F827-CEF667F2'
          render={({ state, fullpageApi }) => {
            return (
              <ReactFullpage.Wrapper>
                <ThemeSwitch />
                <div
                  className='section'
                  id='section-0'
                  style={{
                    backgroundImage: `url(${
                      this.state.isTablet ? img0mobile : img0
                    })`,
                  }}
                >
                  <h1>Fünf Alltagsbegriffe aus dem Ersten Weltkrieg</h1>
                  <p className='lead'>
                    Vor 100 Jahren endete der Erste Weltkrieg, der in unserer
                    Sprache bis heute präsent ist.{' '}
                    <span className='mobile hidden'>
                      Wir verwenden immer noch Begriffe von damals – wenn auch
                      mit anderer Bedeutung.
                    </span>
                  </p>
                  <div className='scroll-hint'>
                    <p style={{ textAlign: 'center' }}>
                      Bitte scrollen
                      <div className='icon-wrapper'>
                        <i className='icon angle down huge' />
                      </div>
                    </p>
                  </div>
                  <div className='caption'>
                    Französische Offiziere inspizieren 1916 die Schützengräben
                    der Argonne-Front in Ostfrankreich. Foto: Reuters / Sammlung
                    Odette Carrez
                  </div>
                </div>

                <div className='section topAlignedText' id='section-1'>
                  <img
                    src={require('./img/trenchcoat.svg')}
                    alt='trenchcoat'
                    className='ui symbol image trenchcoat'
                  />
                  <h2>Trenchcoat</h2>
                  <p className='usage-example'>
                    <span style={{ color: '#E1B370' }}>«</span>Ich habe mir
                    einen super schicken Trenchcoat gekauft.
                    <span style={{ color: '#E1B370' }}>»</span>
                  </p>
                  <p>
                    Humphrey Bogart und Audrey Hepburn wurden damit zu
                    Film-Legenden, Inspektor Columbo ist ohne ihn nicht denkbar.
                    Der Trenchcoat ist ein Modeklassiker. Seinen ersten Auftritt
                    hatte der «Grabenmantel» aber im Ersten Weltkrieg:
                    Britischen und französischen Soldaten half er im Schlamm des
                    Schützengrabens (englisch: trench) beim Überleben: Er hielt
                    Nässe ab, in seine Taschen passten Fernglas und Karte, am
                    Gürtel wurden Waffen befestigt. Die Schulterklappen –
                    ursprünglich für Rangabzeichen – zeugen noch heute vom
                    militärischen Zweck.
                  </p>
                </div>
                <div
                  className='section topAlignedText'
                  id='section-2'
                  style={{
                    backgroundImage: `url(${
                      this.state.isMobile
                        ? imgTrenchMobile
                        : this.state.isTablet
                        ? imgTrenchTablet
                        : imgTrench
                    })`,
                  }}
                >
                  <p className='shadowed'>
                    Durch den Stellungskrieg an der Westfront entstand ein 770
                    Kilometer langes Grabensystem (englisch: trench), das Europa
                    vom Jura bis zur Nordsee durchfurchte.
                  </p>
                  <div className='caption'>
                    Foto: Mary Evans Picture Library
                  </div>
                </div>
                <div className='section inverted topAlignedText' id='section-3'>
                  <img
                    src={require('./img/wummern.svg')}
                    alt='wummern'
                    className='ui symbol image wummern'
                  />
                  <h2>wummern</h2>
                  <p className='usage-example'>
                    <span style={{ color: '#E1B370' }}>«</span>In der Nacht
                    haben wieder die Bässe von oben gewummert.
                    <span style={{ color: '#E1B370' }}>»</span>
                  </p>
                  <p>
                    Wummernde Bässe sorgen heute in Clubs meist für gute
                    Stimmung. Im Ersten Weltkrieg waren sie eine permanente
                    Erinnerung an den Schrecken – an den Sound der
                    Schlachtfelder. Das Verb wummern stand im Krieg für den
                    dumpfen Klang von schweren Geschützen aus der Ferne.
                    Schriftsteller Ernst Jünger schrieb «In Stahlgewittern»
                    (1920): «Für dieses Brodeln entfernten Kanonendonners hatten
                    wir den klangvollen Frontausdruck ‹Es wummert› geprägt.»
                  </p>
                  <div className='smallphone-hidden'>
                    <h4>Artilleriefeuer in der Ferne</h4>
                    <AudioPlayer
                      source={require('./audio/wummern.mp3')}
                      audioTitle='Tonbeispiel: Artilleriefeuer in der Ferne'
                    />
                  </div>
                </div>
                <div className='section topAlignedText' id='section-4'>
                  <img
                    src={require('./img/riemen.svg')}
                    alt='riemen'
                    className='ui symbol image riemen'
                  />
                  <h2>sich am Riemen reissen</h2>
                  <p className='usage-example'>
                    <span style={{ color: '#E1B370' }}>«</span>Wenn du dich
                    nicht endlich am Riemen reisst und lernst, dann rauschst du
                    durch die Mathe-Prüfung.
                    <span style={{ color: '#E1B370' }}>»</span>
                  </p>
                  <p>
                    Am Riemen reissen steht dafür, sich bei einer Sache Mühe zu
                    geben und durchzuhalten, auch wenn man eigentlich keine Lust
                    dazu hat. Die Redewendung stammt aus dem Soldatenjargon des
                    Ersten Weltkriegs. Der Riemen bezeichnete den Gürtel der
                    Uniform. Sass er stramm und korrekt in der Mitte, ging das
                    einher mit einer entsprechend inneren Haltung – glaubte man.
                  </p>
                </div>
                <div className='section inverted topAlignedText' id='section-5'>
                  <img
                    src={require('./img/bahnhof.svg')}
                    alt='bahnhof'
                    className='ui symbol image bahnhof'
                  />
                  <h2>nur Bahnhof verstehen</h2>
                  <p className='usage-example'>
                    <span style={{ color: '#E1B370' }}>«</span>Lass uns das
                    Thema ganz schnell beenden! Ich verstehe sowieso nur
                    Bahnhof.<span style={{ color: '#E1B370' }}>»</span>
                  </p>
                  <p>
                    «Ich verstehe nur Bahnhof», so würgten kriegsmüde Soldaten
                    im Ersten Weltkrieg lakonisch Gespräche ab. Noch heute
                    bekundet man damit, dass man nichts versteht – oder einfach
                    nichts verstehen will. Die Redewendung soll zu dieser Zeit
                    entstanden sein. Die Eisenbahn war damals der
                    Truppentransporter schlechthin: Mit ihr ging es in Richtung
                    Front – aber auch nach Hause. So wurde der Bahnhof zum
                    Symbol für den Heimaturlaub und später für die endgültige
                    Heimkehr.
                  </p>
                </div>
                <div className='section topAlignedText' id='section-6'>
                  <img
                    src={require('./img/0815.svg')}
                    alt='0815'
                    className='ui symbol image nullacht'
                  />
                  <h2>Nullachtfünfzehn</h2>
                  <p className='usage-example'>
                    <span style={{ color: '#E1B370' }}>«</span>Man kann zwar
                    schön sitzen, das Essen ist aber einfach zu teuer für
                    Nullachtfünfzehn.<span style={{ color: '#E1B370' }}>»</span>
                  </p>
                  <p>
                    08/15 war die Nummer des im deutschen Heer verwendeten
                    wassergekühlten Maschinengewehrs 08 in der Version des
                    Jahres 1915. Heute bezeichnet der Begriff 08/15
                    Standardware, Gewöhnliches ohne einen Funken Originalität.
                    Diese übertragene Bedeutung entstand wohl in den
                    1930er-Jahren, als die im Heer immer noch gebräuchlichen,
                    aber inzwischen veralteten 08/15-Maschinengewehre durch
                    modernere Waffen ersetzt wurden.
                  </p>
                </div>
                <div className='section' id='section-7' style={{ padding: 0 }}>
                  <Footer
                    articleId={ARTICLE_ID}
                    publicationDate={this.state.publicationDate}
                  />
                </div>
              </ReactFullpage.Wrapper>
            )
          }}
        />
      </div>
    )
  }
}

export default hot(module)(AppComponent)
